"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledAttributeTitleWrapper = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledAttributeTitleWrapper = styled_components_1.default.div `
    display: inline-flex;
    align-items: center;
    gap: 4px;
    max-width: 100%;
    overflow: hidden;

    p {
      max-width: 200px;
      overflow: hidden;
      text-overflow: ellipsis;
      margin: 0;
    }
`;
